import React from 'react';
import styled from 'styled-components';

import { Marker as UnstyledMarker } from '@xingternal/marker';

import { JobMatchingHighlightsV2Fragment, Maybe } from '@/graphql/generated';

type Props = {
  matchingHighlights?: Maybe<JobMatchingHighlightsV2Fragment>;
};

export const Marker = styled(UnstyledMarker)`
  width: fit-content;
`;

export const MatchingHeader: React.FC<Props> = ({ matchingHighlights }) =>
  matchingHighlights?.highlight ? (
    <Marker variant="highlight">{matchingHighlights.highlight.localization.localizationValue}</Marker>
  ) : null;
